import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-ink text-bone relative zb-grain" data-testid="footer">
      <div className="h-[3px] bg-clay" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14">
        <div className="flex items-start gap-3 rounded-md border border-bone/15 bg-carddark p-5 sm:p-6 mb-12">
          <ShieldCheck className="h-5 w-5 text-sage shrink-0 mt-0.5" />
          <p className="text-sm leading-relaxed text-bone/80" data-testid="footer-disclaimer">
            General wellbeing information only — not medical advice, diagnosis, or treatment. Supplements can cause
            side effects and interact with medicines. Check with a qualified doctor, dietitian, or pharmacist if you
            have symptoms, a health condition, take medicine, are preparing for surgery, or are unsure.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2">
            <p className="font-serif text-4xl font-extrabold uppercase tracking-tight mb-2">
              Zinda<span className="text-clay">Banda</span>
            </p>
            <p className="text-sm text-bone/60 max-w-xs">
              The evidence-led vitality system for men. Food first. Evidence graded. Safety gated. No commerce.
            </p>
          </div>
          <div>
            <p className="font-sans text-[11px] font-bold uppercase tracking-[0.2em] text-clay mb-4">Platform</p>
            <ul className="space-y-2.5 text-sm">
              <li><Link data-testid="footer-link-checkin" to="/check-in" className="text-bone/75 hover:text-clay transition-colors">The Zinda Banda test</Link></li>
              <li><Link data-testid="footer-link-evidence" to="/evidence" className="text-bone/75 hover:text-clay transition-colors">Evidence hub</Link></li>
              <li><Link data-testid="footer-link-insights" to="/insights" className="text-bone/75 hover:text-clay transition-colors">Insights</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-sans text-[11px] font-bold uppercase tracking-[0.2em] text-clay mb-4">Trust</p>
            <ul className="space-y-2.5 text-sm">
              <li><Link data-testid="footer-link-method" to="/method" className="text-bone/75 hover:text-clay transition-colors">How we decide</Link></li>
              <li><Link data-testid="footer-link-safety" to="/safety" className="text-bone/75 hover:text-clay transition-colors">Safety gates</Link></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-bone/10 pt-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-bone/40">
            zindabanda.com — no ads, no affiliate links, no sponsored pills
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-bone/40">
            Anonymous by design · plans expire in 30 days
          </p>
        </div>
      </div>
    </footer>
  );
}
